<template>
  <div class="detentions-datatable-container">
    <ActionPanel
      v-if="false"
      @tab-clicked="setActiveTab"
      class="mb-3"
      :tabs="tabs"
      :help-button="true"
      help-button-content-key="tardy_detentions_assigned_staff"
    >
      <template #right-content>
        <IconButton
          v-if="!isDetentionMode"
          smaller
          icon="lh-normal ri-add-line"
          class="solid full-rounded"
          @click="showDetentionAdultForm"
        ></IconButton>
      </template>
    </ActionPanel>
    <DataTable :fields="activeTable.fields" :items="activeTable.items">
      <template #name="{ item }">
        <td
          :style="detentionNameCellStyle(item)"
          :aria-label="detentionNameAriaLabel(item)"
        >
          {{ item.name }}
        </td>
      </template>
      <template #room="{ item }">
        <td>{{ item.room.name }}</td>
      </template>
      <template #max_cap="{ item }">
        <td>
          {{ item.max_cap === null ? "-" : item.max_cap }}
        </td>
      </template>
      <template #action="{ item }">
        <td class="text-end">
          <Actions
            v-if="activeTable"
            :actions="activeTable.actions"
            @click-action="handleTableAction($event, item)"
          >
          </Actions>
        </td>
      </template>
    </DataTable>
  </div>
</template>

<script>
import { onMounted, computed, reactive, inject } from "vue"
import { useStore } from "vuex"
import ActionPanel from "@/v3components/shared/DataTable/ActionPanel.vue"
import DataTable from "@/v3components/shared/DataTable/DataTable.vue"
import Actions from "@/v3components/shared/DataTable/Actions.vue"
import DetentionForm from "@/v3components/Forms/CreateTardyDetentionForm.vue"
import AddDetentionAdultForm from "@/v3components/Forms/AddDetentionAdultForm.vue"
import IconButton from "@/v3components/shared/Buttons/IconButton.vue"
export default {
  name: "TardyDetentionsTable",
  components: { ActionPanel, DataTable, Actions, IconButton },
  setup() {
    const store = useStore()
    const modal = inject("modal")
    const actionDialog = inject("actionDialog")

    const state = reactive({
      isProcessing: false,
      activeTab: null
    })

    onMounted(() => {
      state.activeTab = tabs[0]
      getDetentions()
    })

    const activeSchool = computed(() => store.getters["schools/activeSchool"])
    const activeTable = computed(() => {
      return !isDetentionMode.value
        ? {
            items: detentionAdults.value,
            fields: detentionAdultsTableFields,
            actions: detentionAdultsActions
          }
        : {
            items: detentions.value,
            fields: detentionTableFields,
            actions: detentionActions
          }
    })

    //detentions
    const detentions = computed(() => store.getters["detentions/detentions"])
    const editableDetention = computed(
      () => store.getters["detentions/editableDetention"]
    )
    const isDetentionMode = computed(
      () => state.activeTab && state.activeTab.value === "detentions"
    )
    const getDetentions = () => {
      store.dispatch("detentions/getDetentions")
    }
    const deleteDetention = (item) => {
      state.isProcessing = true
      store.dispatch("detentions/deleteDetention", item.id).finally(() => {
        state.isProcessing = false
      })
    }
    const detentionActions = [
      { label: "Edit", icon: "ri-checkbox-circle-line", action: "edit" },
      {
        label: "Delete",
        icon: "ri-delete-bin-line",
        class: "important",
        action: "delete"
      }
    ]
    const detentionTableFields = [
      { key: "name", label: "Detention name", sorter: false, filter: false },
      { key: "room", label: "Room", sorter: false, filter: false },
      {
        key: "max_cap",
        label: "Max capacity",
        _style: "width: 150px",
        sorter: false,
        filter: false
      },
      {
        key: "action",
        label: "Action",
        _style: "text-align:end; width: 50px",
        sorter: false,
        filter: false
      }
    ]
    //detentionAdults
    const detentionAdults = computed(
      () => store.getters["detentionAdults/detentionAdults"]
    )
    const getDetentionAdults = () => {
      store.dispatch("detentionAdults/getDetentionAdults")
    }
    const deleteDetentionAdult = (adult) => {
      state.isProcessing = true
      store
        .dispatch("detentionAdults/deleteDetentionAdult", {
          user_id: adult.id,
          school_id: activeSchool.value.id
        })
        .finally(() => {
          state.isProcessing = false
        })
    }
    const showDetentionAdultForm = () => {
      modal.open(AddDetentionAdultForm, {
        size: "sm",
        title: "Add new adult that can take detention"
      })
    }
    const detentionAdultsActions = [
      {
        label: "Delete",
        icon: "ri-delete-bin-line",
        class: "important",
        action: "delete"
      }
    ]
    const detentionAdultsTableFields = [
      { key: "first_name", label: "Adult FN", sorter: false, filter: false },
      { key: "last_name", label: "Adult LN", sorter: false, filter: false },
      { key: "email", label: "Email", sorter: false, filter: false },
      {
        key: "action",
        label: "Action",
        _style: "text-align:end; width: 50px",
        sorter: false,
        filter: false
      }
    ]
    //table
    const tabs = [
      {
        label: "Detentions",
        value: "detentions",
        action: getDetentions
      },
      {
        label: "Assigned Staff",
        value: "assignedStuff",
        action: getDetentionAdults
      }
    ]
    const setActiveTab = (tab) => {
      state.activeTab = tab
      try {
        tab.action()
      } catch (error) {
        throw new Error(error)
      }
    }
    const handleTableAction = (event, item) => {
      if (event.action == "delete") {
        actionDialog.open(
          isDetentionMode.value ? deleteDetention : deleteDetentionAdult,
          {
            args: item,
            props: { danger: true, title: "Delete", question: "Are you sure?" }
          }
        )
      } else {
        store.commit("detentions/SET_EDITABLE_DETENTION", item)
        modal.open(DetentionForm, {
          size: "sm",
          title: "Modify detention",
          props: {
            editableDetention
          }
        })
      }
    }

    const parseColorToRgb = (color) => {
      if (!color || typeof color !== "string") return null
      const trimmed = color.trim()
      if (trimmed === "white" || trimmed === "#fff" || trimmed === "#ffffff") {
        return { r: 255, g: 255, b: 255 }
      }
      const rgbMatch = trimmed.match(
        /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i
      )
      if (rgbMatch) {
        return {
          r: Number(rgbMatch[1]),
          g: Number(rgbMatch[2]),
          b: Number(rgbMatch[3])
        }
      }
      if (!trimmed.startsWith("#")) return null
      let hex = trimmed.slice(1)
      if (hex.length === 3) {
        hex = hex
          .split("")
          .map((c) => c + c)
          .join("")
      }
      if (hex.length !== 6) return null
      const n = Number.parseInt(hex, 16)
      if (Number.isNaN(n)) return null
      return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 }
    }

    const linearizeSrgbChannel = (c) => {
      const s = c / 255
      return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4)
    }

    const relativeLuminance = (rgb) => {
      if (!rgb) return 0
      const R = linearizeSrgbChannel(rgb.r)
      const G = linearizeSrgbChannel(rgb.g)
      const B = linearizeSrgbChannel(rgb.b)
      return 0.2126 * R + 0.7152 * G + 0.0722 * B
    }

    const contrastRatio = (L1, L2) => {
      const hi = Math.max(L1, L2)
      const lo = Math.min(L1, L2)
      return (hi + 0.05) / (lo + 0.05)
    }

    /** WCAG 2.1 §1.4.3: pick #fff vs #1a1a1a for ≥4.5:1 on typical detention badge colors (2173827, 2173836). */
    const accessibleTextOnBackground = (bgCss) => {
      const rgb = parseColorToRgb(bgCss)
      if (!rgb) return "#1a1a1a"
      const Lbg = relativeLuminance(rgb)
      const Lwhite = 1
      const nearBlack = relativeLuminance({ r: 26, g: 26, b: 26 })
      const cWhite = contrastRatio(Lbg, Lwhite)
      const cBlack = contrastRatio(Lbg, nearBlack)
      if (cWhite >= 4.5) return "#ffffff"
      if (cBlack >= 4.5) return "#1a1a1a"
      return cBlack >= cWhite ? "#1a1a1a" : "#ffffff"
    }

    const detentionNameCellStyle = (item) => {
      const bg = item?.color ? item.color : "#ffffff"
      return {
        backgroundColor: bg,
        color: accessibleTextOnBackground(bg),
        borderInlineStart: item?.color ? `4px solid ${item.color}` : undefined
      }
    }

    const detentionNameAriaLabel = (item) => {
      const name = item?.name || ""
      if (!item?.color) return name
      return `${name}, row uses detention color ${item.color}`
    }

    const isColorDark = (color) => {
      if (!color || color === "white") {
        return false
      }
      let r, g, b
      // Check the format of the color, HEX or RGB?
      if (color.match(/^rgb/)) {
        // If HEX --> store the red, green, blue values in separate variables
        color = color.match(
          /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
        )

        r = color[1]
        g = color[2]
        b = color[3]
      } else {
        // If RGB --> Convert it to HEX
        color = +(
          "0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&")
        )

        r = color >> 16
        g = (color >> 8) & 255
        b = color & 255
      }

      // HSP (Highly Sensitive Poo)
      const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

      // Using the HSP value, determine whether the color is light or dark
      if (hsp > 148.5) {
        return false
      } else {
        return true
      }
    }

    return {
      tabs,
      setActiveTab,
      handleTableAction,
      activeTable,
      showDetentionAdultForm,
      isDetentionMode,
      isColorDark,
      detentionNameCellStyle,
      detentionNameAriaLabel
    }
  }
}
</script>
